export default "__VITE_ASSET__CdOirdfg__"